import { useState, useEffect } from "react";
import { useTherapist } from "../../../context/useTherapist";

export type SubscriptionPlan = "basic" | "plus";

export function useSubscription() {
    const { therapist, loadingTherapist } = useTherapist();
    const [plan, setPlan] = useState<SubscriptionPlan>("basic");

    useEffect(() => {
        if (therapist?.subscription_type) {
            setPlan(therapist.subscription_type);
        } else {
            setPlan("basic");
        }
    }, [therapist]);

    const isPremium = plan === "plus";

    return {
        plan,
        isPremium,
        loading: loadingTherapist
    };
}
